import { Component, OnInit, HostListener, NgModule, ViewChild, AfterViewInit, NgZone } from "@angular/core";
import { NavController, MenuController } from "@ionic/angular";
import { AppService } from "../services/app.service";
import { HttpService } from "../services/http.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SyncService } from "../services/sync.service";
import { AlertController } from "@ionic/angular";
import { DomSanitizer } from "@angular/platform-browser";
import { Title, Meta } from "@angular/platform-browser";

import { Observable, ZenObservable } from "zen-observable-ts";
import { connectableObservableDescriptor } from "rxjs/internal/observable/ConnectableObservable";
import { v4 as uuidv4 } from "uuid";

import {
  Client,
  State,
  Conversation,
  ConversationUpdateReason,
  Message,
  SendMediaOptions,
  Paginator,
  MessageUpdateReason,
  Participant,
  ParticipantUpdateReason,
} from "@twilio/conversations";

import { throwError } from "rxjs";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { fromEvent, merge as observableMerge } from "rxjs";
import { Swiper } from "swiper/types";

//twilio video
declare var document: any;

declare var participantConnected;
declare var participantDisconnected;
declare var viewLink;
declare var mappedinDirectory;
//end twilio video

@Component({
  selector: "app-exp",
  templateUrl: "./exp.page.html",
  styleUrls: ["./exp.page.scss"],
})
export class ExpPage implements OnInit {
  private userActivity = new Subject<void>();

  subscription: ZenObservable.Subscription;
  flags: any;
  room: any;

  client: any;
  conversation: any;
  token: any = null;
  params: any = null;
  sessionID: any = null;
  showSplashScreen: boolean = true;
  tokenData: any = null;
  siteID: any = null;
  folderID: any = null;
  resourceID: any = null;
  utmText: any = null;

  Video: any = require("twilio-video");
  @ViewChild("swiperComponent") swiperComponent: Swiper;
  mobileScreen: boolean = window.innerWidth < 768;

  constructor(
    public app: AppService,
    private sanitizer: DomSanitizer,
    public menuCtrl: MenuController,
    public sync: SyncService,
    private navCtrl: NavController,
    public http: HttpService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public alertController: AlertController,
    public title: Title,
    private meta: Meta,
    private zone: NgZone
  ) {
    //http://localhost:8100/exp/1/16/support/82/155
    this.checkScreenSize();

    this.flags = {
      resetTimer: 45000,
      confirmationTimer: 15000,
      identity: "Client",
      date: Date.now(),
      sid: null,
      editSite: null,
      currentCategory: null,
      currentEntry: null,

      contactOption: null,

      twilioConnectionMode: 3,
      twilioConnectionVideo: false,

      convoNewMessage: "",
      convoSysMessage: null,
      convoMessages: [],
      convoVideoParams: { audio: true, video: true },
      convoPauseState: 0,

      supportView: 0,
      endingSurvey: false,

      sessionID: null,
      session: null,
      connectionType: null,
      completeSession: false,
      currentSlide: 0,
      responses: [],
      directoryListings: [],

      appSync: null,
      increment: 0,

      site: null,
      showVideo: true,
      showImage: true,

      defaultSession: {
        status: 1,
        data: { url: null },
        company_id: null,
        site_id: null,
        device_id: null,
        epoch: null,
        name: "New Request",
        responses: {},
        commands: {},
        notes: "",
      },
    };

    //company 1 > arii
    //site 10 > kingsway
    //device 82 > DC Test

    this.monitorUserActivity();
  }

  userInteracted() {
    this.userActivity.next();
  }

  private monitorUserActivity() {
    //this.app.alert('starting monitor');
    const events = ["mousemove", "click", "keydown", "touchstart"];
    const activityEvents = events.map((eventName) => fromEvent(document, eventName));
    observableMerge(...activityEvents)
      .pipe(debounceTime(this.flags.resetTimer))
      .subscribe(() => {
        console.log("User didn't interact for the last 10 seconds, reset experience!");

        // Here reset your experience
        //this.fullReset();

        if (
          this.flags.device.type != "kiosk" ||
          this.sessionID ||
          (this.flags.currentCategory == null &&
            this.flags.currentEntry == null &&
            this.flags.showVideo &&
            this.flags.showImage)
        ) {
          console.log("Not running automated reset");
        } else {
          this.flags.resetTrigger = true;
          this.openModal(0, null);
          setTimeout(() => {
            if (this.flags.resetTrigger) {
              this.fullReset();
            }
          }, this.flags.confirmationTimer);
        }
      });
  }

  fullReset() {
    //this.app.toast('Resetting', 'dark');
    //this.app.alert('full Reset');
    //this.flags.appSync && flags.sites && !flags.editSite && flags.showImage
    //this.flags.showImage = true;

    this.flags.transferedSession = false;
    console.log("resetting experience");
    this.closeModal();
    this.homeButton(0);
    this.navCtrl.navigateRoot("/e/" + this.token);
    this.title.setTitle(this.flags.editSite.name);
  }

  //SCREEN RESIZE LISTENER
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    // Using NgZone to ensure the view updates
    this.zone.run(() => {
      this.mobileScreen = window.innerWidth < 768;
    });
  }

  checkScreenSize() {
    this.mobileScreen = window.innerWidth < 768;
  }
  //END SCREEN RESIZE LISTENER

  shareButton() {
    navigator.share({
      title: this.flags.editSite.name,
      text: "Find out more about " + this.flags.editSite.name + " by visiting their experience page.",
      url: "https://wecare.helloarii.com/e/" + this.token,
    });
  }

  ionViewWillEnter() {
    this.flags.appSync = null;
    this.menuCtrl.enable(false);

    this.token = this.activatedRoute.snapshot.paramMap.get("token");
    this.sessionID = this.activatedRoute.snapshot.paramMap.get("session_id");
    console.log("CHECK IF SESSION IS COMING >>> " + this.sessionID); // Here the session_id is coming as params
    // this.params = this.activatedRoute.snapshot.paramMap.get("params");
    // console.log("CHECK IF PARAMS IS COMING >>> " + this.params); // Here the session_id is coming as params

    if (this.token) {
      this.getData();
      //this.getSites();
    }

    // Checking if the current route includes '/params'
    if (this.router.url.includes("/params")) {
      console.log("The URL contains '/params', processing query parameters.");
      // Subscribe to queryParams
      this.activatedRoute.queryParams.subscribe((queryParams) => {
        // Check if all required query parameters are present
        if (
          queryParams.hasOwnProperty("siteID") ||
          queryParams.hasOwnProperty("folderID") ||
          queryParams.hasOwnProperty("resourceID")
        ) {
          this.siteID = queryParams["siteID"];
          this.folderID = queryParams["folderID"];
          this.resourceID = queryParams["resourceID"];

          console.log("Site ID:", this.siteID);
          console.log("Folder ID:", this.folderID);
          console.log("Resource ID:", this.resourceID);

          this.loadResource(this.siteID, this.folderID, this.resourceID);
        }
        if (queryParams.hasOwnProperty("adTitle") && !this.siteID && !this.folderID && !this.resourceID) {
          this.utmText = queryParams["adTitle"].split("%20").join(" ");
          console.log(">>> UTM Text:", this.utmText);
          setTimeout(() => {
            this.showSplashScreen = false;
          }, 3000);
        }
        if (queryParams.hasOwnProperty("adTitle")) {
          this.utmText = queryParams["adTitle"].split("%20").join(" ");
          console.log(">>> UTM Text:", this.utmText);
        } else {
          // Handle the absence of required query parameters
          console.log("Query parameters are missing for resource loading.");
        }
      });
    } else {
      console.log("The URL does not contain '/params', skipping query parameter processing.");
    }

    // this.company_id = this.activatedRoute.snapshot.paramMap.get('company_id');
    // this.site_id = this.activatedRoute.snapshot.paramMap.get('site_id');
    // this.function = this.activatedRoute.snapshot.paramMap.get('function');
    // this.device_id = this.activatedRoute.snapshot.paramMap.get('device_id');
    //this.subscribe();
  }

  loadResource(siteID, folderID, resourceID) {
    this.showSplashScreen = true;

    // Helper function to create a delay using Promise
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    delay(3200) // Initial delay to mimic loading
      .then(() => {
        let siteIndex = this.flags.sites.findIndex((site) => site.id === Number(siteID));
        this.selectSite(siteIndex);
        console.log("Selected the site ID >>>", siteID);
        return delay(200); // Delay before possibly selecting a category
      })
      .then(() => {
        if (folderID) {
          let folderIndex = this.flags.editSite.join.findIndex((category) => category.id === Number(folderID));
          this.flags.currentCategory = this.flags.editSite.join[folderIndex];
          this.title.setTitle(this.flags.editSite.name + " > " + this.flags.currentCategory.name);
          console.log("Selected the folder ID >>> ", folderID);
          return delay(200); // Delay before possibly selecting an entry
        }
      })
      .then(() => {
        if (resourceID && this.flags.currentCategory) {
          let resourceIndex = this.flags.currentCategory.entries.findIndex((entry) => entry.id === Number(resourceID));
          this.flags.currentEntry = this.flags.currentCategory.entries[resourceIndex];
          this.title.setTitle(
            this.flags.editSite.name + " > " + this.flags.currentCategory.name + " > " + this.flags.currentEntry.name
          );
          console.log("Selected the resource ID >>> ", resourceID);
          return delay(200); // Final delay after selecting entry
        }
      })
      .then(() => {
        this.showSplashScreen = false; // Hide splash screen after all actions are completed
      })
      .catch((error) => {
        console.error("Error loading resources:", error);
        this.showSplashScreen = false; // Ensure splash screen is hidden even if there's an error
      });
  }

  resetTimer() {
    this.app.toast("Resetting", "success");
    this.flags.resetTimer = 0;
    this.navCtrl.navigateRoot("/e/" + this.token);
  }

  getData() {
    //GET SITE INFO
    this.http
      .get("https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/device/" + this.token)
      .then((data) => {
        if (data["data"]) {
          console.log("GOT DATA", data);
          var obj = data["data"];
          obj.settings = JSON.parse(obj.settings);
          obj.site_settings = JSON.parse(obj.site_settings);

          for (var o in obj.sites) {
            //iterate through query
            obj.sites[o].contacts = JSON.parse(obj.sites[o].contacts);
            obj.sites[o].settings = JSON.parse(obj.sites[o].settings);
            obj.sites[o].directory = JSON.parse(obj.sites[o].directory);
            obj.sites[o].api_directory = JSON.parse(obj.sites[o].api_directory);

            for (var i in obj.sites[o].join) {
              //iterate through query
              obj.sites[o].join[i].entries = JSON.parse(obj.sites[o].join[i].entries);
              obj.sites[o].join[i].settings = JSON.parse(obj.sites[o].join[i].settings);
            }
            obj.sites[o].instance_settings = obj.site_settings.find((e) => e.id == obj.sites[o].id);
          }

          this.flags.device = obj;
          this.flags.sites = obj.sites;
          console.log("FORMATTED ", obj);

          // Meta Title and Meta Description
          this.title.setTitle(obj.settings.apSEOTitle);
          this.meta.updateTag({ name: "description", content: obj.settings.apSEODesc });

          //if a single site then just go directly to experience
          if (this.flags.sites.length == 1 && !this.flags.device.settings.links.length) {
            this.selectSite(0);
          }

          //if session id is passed then subscribe to the ticket
          if (this.sessionID) {
            this.subscribe();
          }
        }
      });
  }

  selectSite(i) {
    if (i != null) {
      this.flags.currentSite = i;
    } //set current site if passed index

    this.flags.showVideo = true;
    var obj = JSON.parse(JSON.stringify(this.flags.sites[this.flags.currentSite]));
    this.flags.editSite = obj;
    console.log("SELECTED STIE", obj);

    //VCARD
    var vcard = " BEGIN:VCARD\nVERSION:4.0";
    vcard += "\nFN:" + this.flags.editSite.name;
    vcard += "\nTEL;TYPE=WORK:" + this.flags.editSite.settings.supportPhoneLink;
    vcard += "\nEMAIL:" + this.flags.editSite.email;
    vcard += "\nADR:" + this.flags.editSite.address;
    vcard += "\nURL:" + this.flags.editSite.website;
    vcard += "\nEND:VCARD";
    this.flags.editSite.vcard = vcard;

    this.flags.currentCategory = null;
    this.flags.currentEntry = null;
    this.title.setTitle(this.flags.editSite.name);
  }

  selectCategory(item) {
    this.flags.currentCategory = item;
    this.flags.showVideo = true;
    this.scrollTop();
    this.title.setTitle(this.flags.editSite.name + " > " + item.name);
  }

  selectEntry(item) {
    if (item.type == "external") {
      window.open(item.target, "_blank");
    } else {
      this.flags.currentEntry = item;
      this.flags.showVideo = true;
      this.scrollTop();

      if (item.type == "directory") {
        this.loadMappedinDirectory();
      }
    }
    this.title.setTitle(this.flags.editSite.name + " > " + this.flags.currentCategory.name + " > " + item.name);
  }

  openLink(item) {
    window.open(item.target, "_blank");
  }

  scrollTop() {
    var element = document.getElementById("supportPage");
    element.scrollTop = 0;
  }

  scrollBottom() {
    var element = document.getElementById("supportPage");
    element.scrollTop = element.scrollHeight;

    this.flags.animateContact = true;
    setTimeout(() => {
      this.flags.animateContact = false;
    }, 1000);
  }

  homeButton(m) {
    // Meta Title and Meta Description
    this.title.setTitle(this.flags.device.settings.apSEOTitle);
    this.flags.currentCategory = null;
    this.flags.currentEntry = null;

    this.flags.showVideo = false;
    this.flags.showImage = false;

    var element = document.getElementById("supportPage");
    if (element) {
      element.scrollTop = 0;
    }

    if (m == 0) {
      this.flags.showVideo = true;
      this.flags.showImage = true;
    }

    //take back to site selection screen
    if (this.flags.sites.length > 1) {
      this.flags.editSite = null;
    }
  }

  transferedSession() {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("transfer")) {
      this.flags.transferedSession = true;
      this.flags.showVideo = false;
      //this.app.alert('video override ' + this.flags.showVideo);
    }
  }

  createSession(m) {
    this.flags.showVideo = false;
    this.app.load("Connecting", 1000);
    this.app.flags.connectionType = m; //set flag for defaulting the camera on or off

    var source = "chat";
    if (this.flags.device.type == "kiosk") {
      source = "kiosk";
    }

    var obj = {
      token: this.token,
      site_id: this.flags.editSite.id,
      source_type: source,
    };

    // var obj2 = {
    //   site_id: this.flags.editSite.id,
    //   device_id: this.flags.device.id,
    //   company_id: this.flags.editSite.company_id,
    //   language: this.flags.editSite.language,
    //   source_type: source,
    //   source: this.flags.device.name
    // }

    this.http
      .post("https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/device/" + this.token, obj)
      .then((data) => {
        //this.app.toast('Saved', 'success');
        console.log(data);

        if (data["data"].insertId) {
          //this.sessionID = data['data'].insertId;
          //this.subscribe();
          //navigate to new page
          var id = data["data"].insertId;
          this.navCtrl.navigateRoot("/e/" + this.token + "/" + id);
        }

        //this.getSites();
        //this.reset();
      });
  }

  reset() {
    this.flags.showImage = true;
    this.flags.showVideo = true;
    this.navCtrl.navigateRoot("/e/" + this.token);
  }

  //  updateFeed() { //notify app sync to refresh
  //   var obj = '{}';

  //   var syncTarget = 'comp-' + this.flags.device.company_id;

  //   this.sync.UpdateSync({ id: syncTarget, status: status, data: obj, responses: 'null', commands: 'companySessions', settings: 'null' }).then(data => {
  //     console.log(data.data);
  //     console.log('Sync updated', data);
  //     //this.flags.appSync = data;
  //   });
  // }

  rating(m) {
    this.flags.appSync.rating = m;
  }

  openModal(m, params) {
    this.flags.modalMode = m;
    this.flags.modalStep = 1;

    if (params) {
      this.flags.modalData = params;
      console.log("modal params", params);
    }
  }

  closeModal() {
    this.flags.modalMode = null;
  }

  //START APP SYNC
  subscribe() {
    this.sync.GetMostRecentSync(this.sessionID).then((data) => {
      console.log("inital price from app sync", data);
      this.flags.appSync = data;
      this.renderSession();

      //SELECT SITE FIELDS
      for (let i = 0; i < this.flags.sites.length; i++) {
        if (this.flags.sites[i].id == this.flags.appSync.data.site_id) {
          this.selectSite(i);
        }
      }
      this.app.stopload();
      this.transferedSession();

      // if(!this.conversation && this.flags.appSync.data.status == 'new' || !this.conversation && this.flags.appSync.data.status == 'pending') { //if ticket is still open
      //   this.getTwilioToken(); //connect to twilio face
      // }

      if (this.flags.appSync.data.status == "closed") {
        this.listArchiveMessages();
        this.startSurvey();
        //this.flags.convoMessages = JSON.parse(this.flags.appSync.data.conversation);
      } else if (this.flags.appSync.data.status == "pending") {
        //IF STATUS IS PENDING START SURVEY
        this.startSurvey();
        this.getTwilioToken(); //connect to twilio face
      } else {
        this.getTwilioToken(); //connect to twilio face
      }
    });

    console.log("starting subscription");
    this.subscription = this.sync
      .OnUpdateSyncListener(this.sessionID)
      .map((syncObject) => syncObject.value.data["onUpdateSync"])
      .subscribe(
        (data) => {
          console.log("received update via app sync", data);
          this.flags.appSync.data = data.data;
          this.renderSession();
        },
        (error) => {
          //this.app.alert('error' + error)
          console.log("logged a connection error", error);
          this.reSubscribe();
        }
      );
  }

  unsubscribe() {
    this.subscription.unsubscribe();
    console.log("unsubscribe");
  }

  reSubscribe() {
    this.flags.online = false;
    console.log("subscription dead unsubscribing");
    this.unsubscribe();

    setTimeout(() => {
      console.log("retrying subscription");
      this.subscribe();
    }, 2000);
  }
  //END APP SYNC

  //TWILIO SYSTEMS
  getTwilioToken() {
    //https://www.twilio.com/docs/video/api/rooms-resource#create-room
    var identity = "Client"; //                this.app.sysData.agent_name = data.data[0].name;
    var room = this.sessionID;
    var sid = this.flags.appSync.data.conversation_sid;
    this.http
      .get(
        "https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/twilio/token/?identity=" +
          identity +
          "&room=" +
          room +
          "&sid=" +
          sid
      )
      .then((data) => {
        console.log("GET CHAT/TICKET TOKEN", data);
        //this.app.alert(JSON.stringify(data));
        this.flags.twilioToken = data["token"];
        this.flags.tokenTimer = Date.now(); //current epoch - token is valid for 1 hour

        //TWILIO CONVERSATION INITIALIZER
        this.client = new Client(this.flags.twilioToken);

        this.flags.sid = data["conversationSid"];
        this.getConversation(data["conversationSid"]);

        //buffer launch
        setTimeout(() => {
          this.checkTwilioToken();

          if (this.app.flags.connectionType == "video") {
            console.log("CONNECTIGN TO ROOM-  video on");
            this.twilioConnect(2);
          } else if (this.app.flags.connectionType == "audio") {
            console.log("CONNECTIGN TO ROOM- audio only");
            this.twilioConnect(1);
          } else {
            console.log("CONNECTIGN TO ROOM- no chat no video");
            this.twilioConnect(3);
          }
        }, 800);
      });
  }

  checkTwilioToken() {
    console.log("checking twilio token");
    var epoch = Date.now();
    var expiration = +epoch - +this.flags.tokenTimer;

    if (this.flags.twilioToken) {
      console.log("token timer", expiration);

      if (expiration >= 30 * 60 * 1000) {
        this.refreshTwilioToken();
        //this.getTwilioToken(); //refresh token
        //this.app.alert('Twilio Token needs to be refreshed, please refresh the page.');
      }

      setTimeout(() => {
        this.checkTwilioToken();
      }, 5 * 60 * 1000);
    }
  }

  async refreshTwilioToken() {
    console.log("OLD", this.client);
    //this.client = new Client(this.flags.twilioToken);
    var identity = "Client"; //                this.app.sysData.agent_name = data.data[0].name;
    var room = this.sessionID;
    var sid = this.flags.appSync.data.conversation_sid;

    this.http
      .get(
        "https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/twilio/token/?identity=" +
          identity +
          "&room=" +
          room +
          "&sid=" +
          sid
      )
      .then((data) => {
        this.flags.twilioToken = data["token"];
        this.client = new Client(this.flags.twilioToken);
        this.flags.tokenTimer = Date.now();
        console.log("NEW", this.client);
      });
  }
  // async diagDelete() {
  //   var conversation = await this.client.getConversationByUniqueName('240');
  //   await conversation.delete();
  //   var conversation = await this.client.getConversationByUniqueName('363');
  //   await conversation.delete();
  //   var conversation = await this.client.getConversationByUniqueName('361');
  //   await conversation.delete();
  //   console.log('deleted');
  // }

  getConversation(sid) {
    //https://www.twilio.com/docs/conversations/quickstart#add-an-sms-participant-to-a-conversation
    //https://media.twiliocdn.com/sdk/js/conversations/releases/2.1.0/docs/classes/Client.html#userSubscribed

    //this.client.getConversationByUniqueName(id).then(data => { //get convo by unique name
    this.client
      .getConversationBySid(sid)
      .then((data) => {
        //get convo by sid name
        this.conversation = data; //attach variable to conversation
        console.log("Connected ", data);

        //this.listConversationParticipants()
        this.listMessages(); //list initial messages
        this.subscribeConversation(); //subscribe for updates
      })
      .catch((e) => {
        //this.app.alert('C1: error' + e);

        console.log("CLIENT FAILED ", this.client);
        console.log("NO CONVERSATION EXISTS CREATING A NEW ONE");
        this.app.alert("An error occured connecting to conversation, please try again");
      });
  }

  subscribeConversation() {
    //handle events in the conversation
    this.client.on(
      "conversationUpdated",
      ({ conversation, updateReasons }: { conversation: Conversation; updateReasons: ConversationUpdateReason[] }) => {
        // Fired when the attributes or the metadata of a conversation have been updated
        console.log("something updated in chat" + updateReasons, conversation);
        this.listMessages();
      }
    );
  }

  listArchiveMessages() {
    var messages = JSON.parse(this.flags.appSync.data.conversation);

    for (let i = 0; i < messages.length; i++) {
      //const urlRegex = /((https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?)/gi;
      const urlRegexWebsite = /(website: https?:\/\/[^\s]+)/g;
      var str = messages[i]["state"]["body"];

      console.log(str);
      str = str.replace(urlRegexWebsite, '<a onclick="viewLink(`$1`)" class="pointer">Click to view</a>');
      messages[i]["state"]["message"] = this.sanitizer.bypassSecurityTrustHtml(str);

      this.flags.convoMessages.push(messages[i]);
    }

    this.scrollChat();
  }

  async listMessages() {
    var limit = 1000; //initial load limit
    if (this.flags.convoMessages.length) {
      limit = 1; //subsequent limit
    }

    console.log(limit + "pull");

    let messagesPaginator: Paginator<Message> = await this.conversation.getMessages(limit);
    const messages: Message[] = messagesPaginator.items;

    for (let i = 0; i < messages.length; i++) {
      if (
        limit == 1000 ||
        messages[i]["state"]["sid"] != this.flags.convoMessages[+this.flags.convoMessages.length - 1]["state"]["sid"]
      ) {
        //const urlRegex = /((https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?)/gi;
        const urlRegex = /(website: https?:\/\/[^\s]+)/g;
        var str = messages[i]["state"]["body"];
        const urls = str.match(urlRegex);

        str = str.replace(urlRegex, '<a onclick="viewLink(`$1`)" class="pointer">Click to view</a>');
        messages[i]["state"]["message"] = this.sanitizer.bypassSecurityTrustHtml(str);

        this.flags.convoMessages.push(messages[i]);

        // //CLOSING SCRIPT RUN SURVEY
        // if(messages[i]['state']['body'] == "Thank you for contacting us the ticket is now closed. Please contact us again if you have another inquiry") {
        //   //this.app.alert('trigger close now');
        //   this.startSurvey();
        // }
      }
    }

    this.scrollChat();

    console.log("got messages", this.flags.convoMessages);
    console.log("got messages firect", messages);
  }

  scrollChat() {
    // setTimeout(() => {
    //   // Scroll to the element
    //   const element = document.querySelector('a[name="chatTarget"]');
    //   element.scrollIntoView({ behavior: "smooth" });
    // }, 200);
  }

  async loadMappedinDirectory() {
    const params = {
      venue: this.flags.editSite.settings.directory.venue,
      clientId: this.flags.editSite.settings.directory.id,
      clientSecret: this.flags.editSite.settings.directory.key,
    };

    mappedinDirectory(params).then((data) => {
      // const sortedCategories = [
      //   ...data.categories.sort((a, b) => (a.name! > b.name! ? 1 : 0))
      // ];

      this.flags.directoryListings = data.categories;
      console.log("SORTED CATS", data.categories);
    });
    console.log(params);
  }

  async sendMessage(m) {
    if (this.conversation && this.flags.convoNewMessage && m == 1) {
      var obj: any = this.flags.convoNewMessage;
      this.flags.convoNewMessage = "";
      this.conversation.sendMessage(obj);

      if (this.mobileScreen) {
        document.activeElement.blur();
      }
    }

    if (this.conversation && this.flags.convoSysMessage && m == 2) {
      var obj: any = this.flags.convoSysMessage;
      this.flags.convoSysMessage = "";
      this.conversation.sendMessage(obj);
    }
  }

  twilioConnectPreview(m) {
    if (m == 0) {
      if (this.flags.localVideoTrack) {
        this.flags.localVideoTrack.stop();
      }
      var div = document.getElementById("localVideoFeed");
      if (div) {
        div.remove();
      }
    }
    if (m == 1) {
      //show local preview
      const localVideoElement = document.getElementById("localVideo");
      const div = document.createElement("div");
      div.id = "localVideoFeed";
      div.className = "localVideo";

      this.Video.createLocalVideoTrack()
        .then((track) => {
          this.flags.localVideoTrack = track;
          div.appendChild(track.attach());
          localVideoElement.appendChild(div);
        })
        .catch((error) => {
          console.error(`Error creating local video track: ${error}`);
        });
    }
  }

  twilioConnect(m) {
    if (m) {
      this.flags.twilioConnectionMode = m;
    } //set connection varialbe to match m

    if (this.flags.twilioConnectionMode == 1) {
      //if audio only
      this.flags.convoVideoParams.video = false;
      this.flags.convoVideoParams.audio = true;
      this.flags.convoPauseState = 0;
      this.flags.convoSysMessage = "Audio mode now on";
      this.twilioConnectPreview(0);
    }

    if (this.flags.twilioConnectionMode == 2) {
      //if video and audio
      this.flags.convoVideoParams.video = true;
      this.flags.convoVideoParams.audio = true;
      this.flags.convoPauseState = 0;
      this.flags.convoSysMessage = "Video mode now on";
      this.twilioConnectPreview(1);
    }

    if (this.flags.twilioConnectionMode == 3) {
      //pause
      this.flags.convoVideoParams.video = false;
      this.flags.convoVideoParams.audio = false;
      this.flags.convoPauseState = 1;
      this.flags.convoSysMessage = "Video and Audio mode turned off";
      this.twilioConnectPreview(0);
    }

    this.Video.connect(this.flags.twilioToken, this.flags.convoVideoParams).then((room) => {
      this.room = room;

      if (m == null) {
        this.sendMessage(2);
      }

      console.log("CONNECTED TO ROOM ", room);
      room.participants.forEach(participantConnected);
      room.on("participantConnected", participantConnected);
      room.on("participantDisconnected", participantDisconnected);
      //room.once('disconnected', error => room.participants.forEach(participantDisconnected));
    });
  }

  checkTwilioConnections() {
    console.log("CURRENTLY ACTIVE TWILIO", this.room);
    console.log("size", this.room.participants.size);
    this.flags.twilioConnectionVideo = false;

    this.room.participants.forEach((item) => {
      console.log("for item " + item);
      console.log("sid here", item.sid);
      console.log("tracks here", item.tracks);
    });
  }

  stopTwilioConnect() {
    this.twilioConnectPreview(0);
    this.room.disconnect();
    this.flags.convoSysMessage = "Exited the conversation";
    this.sendMessage(2);
  }
  //END TWILIO SYSTEMS

  renderSession() {
    this.flags.appSync.data = JSON.parse(this.flags.appSync.data);
    this.flags.appSync.data.data = JSON.parse(this.flags.appSync.data.data);
    console.log("rendered data", this.flags.appSync);
    this.title.setTitle("Live Support");

    if (this.flags.appSync.data.status == "closed" || this.flags.appSync.data.status == "pending") {
      this.startSurvey();
    }
    //this.app.alert(this.flags.appSync.data.site_id);

    // for (let i = 0; i < this.flags.sites.length; i++) {
    //   if(this.flags.sites[i].id == this.flags.appSync.data.site_id) {
    //     this.selectSite(i);
    //   }
    // }
    //this.flags.appSync.data.site_id
    //this.flags.editSite
  }

  closeSession() {
    var color = this.flags.editSite.settings.bgColor;
    color = color.replace("#", "");
    this.flags.surveyTarget =
      "https://wecare.helloarii.com/assets/api-survey.html?token=" +
      this.token +
      "&id=" +
      this.sessionID +
      "&image=" +
      this.flags.editSite.settings.surveyImg +
      "&bgimage=" +
      this.flags.editSite.settings.bgImage +
      "&bgcolor=" +
      color;
    this.flags.appSync.data.data.url = this.flags.surveyTarget;

    var sid = this.sessionID;
    this.app.load("Closing", 1000);
    var obj = {
      sid: this.sessionID,
      source_type: "Client",
      company_id: this.flags.editSite.company_id,
      url: this.flags.surveyTarget,
    };
    this.flags.convoSysMessage = "Closed the session and left the conversation.";
    this.sendMessage(2);

    this.http.post("https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/close/" + sid, obj).then((data) => {
      console.log(data);
      this.flags.appSync.data.status = "pending";
      //this.flags.appSync.data.status = 'closed';
      //this.app.toast('ran close', 'success');

      //this.navCtrl.navigateRoot('/e/'+this.token);
    });
  }

  loadLink() {
    //this.flags.endingSurvey = false;

    var url = document.getElementById("directControlTarget").innerHTML;
    this.flags.appSync.data.data.url = url;
  }

  startSurvey() {
    //this.app.alert('closing');
    //this.flags.appSync = null,
    //this.sessionID = null,

    // this.unsubscribe();
    // if(this.room) {
    //   this.stopTwilioConnect();
    // }

    //this.flags.appSync.data.status = 'closed';
    //this.conversation = null;
    this.title.setTitle("Live Support Survey - " + this.flags.editSite.name);
    var color = this.flags.editSite.settings.bgColor;
    color = color.replace("#", "");
    this.flags.surveyTarget =
      "https://wecare.helloarii.com/assets/api-survey.html?token=" +
      this.token +
      "&id=" +
      this.sessionID +
      "&image=" +
      this.flags.editSite.settings.surveyImg +
      "&bgimage=" +
      this.flags.editSite.settings.bgImage +
      "&bgcolor=" +
      color;
    this.flags.appSync.data.data.url = this.flags.surveyTarget;
    //viewLink(target);
    //this.flags.endingSurvey = true;
  }

  submitSurvey() {
    this.flags.endingSurvey = false;
    this.flags.appSync = false;
    this.sessionID = null;

    this.closeSession();
  }

  async presentAlertConfirm() {
    const alert = await this.alertController.create({
      header: "Are you sure?",
      message: "You are about to close your support session",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {
            console.log("Confirm Cancel: blah");
          },
        },
        {
          text: "End Session",
          handler: () => {
            //this.remSetting(m, i);
            this.closeSession();
            //this.startSurvey();
            console.log("Confirm Okay");
          },
        },
      ],
    });

    await alert.present();
  }

  ionViewWillLeave() {
    this.flags.twilioToken = null; ///remove so token checking stops
    if (this.room) {
      this.stopTwilioConnect();
    }
    this.unsubscribe();
  }

  ngOnInit() {
    // Called to update the meta title
    this.getData();

    if (!this.router.url.includes("/params")) {
      console.log("No params");
      setTimeout(() => {
        this.showSplashScreen = false;
      }, 3000);
    }
  }
}
